'use client';

import { UserPlus } from 'lucide-react';

import { Button } from '@/slw/shared/ui/button';

interface SidebarHeaderProps {
  chatCount: number;
  onOpenAddChatModal: () => void;
}

export function SidebarHeader({ chatCount, onOpenAddChatModal }: SidebarHeaderProps) {
  const handleAddUserToChat = () => {
    onOpenAddChatModal();
  };

  return (
    <div className='flex justify-between p-2 items-center'>
      <div className='flex gap-2 items-center text-2xl'>
        <p className='font-medium'>Chats</p>
        <span className='text-zinc-300'>({chatCount})</span>
      </div>

      <div>
        <Button onClick={handleAddUserToChat} color='light' variant='outline'>
          <UserPlus size={20} />
        </Button>
      </div>
    </div>
  );
}
